export default class TaskMutationTrackingService {

    constructor($state) {
        this.$state = $state;
        this.statesWhichCanTriggerTaskMutation = [
            'campaignDetail',
            'campaignContactDetail',
            'contactsDetail',
            'customerContactsDetail',
            'investorsDetail',
            'customerInvestorsDetail',
            'tasks'
        ];
    }

    canTriggerTaskMutation(fromState, toState) {
        // this.displayStatesInConsole(fromState, toState);
        return this.statesWhichCanTriggerTaskMutation.indexOf(toState.name) > -1;
    }

    storeMutationTriggeringStateInSessionStore(state, parameters) {
        sessionStorage.setItem('task-mutation-triggering-state', JSON.stringify(state));
        sessionStorage.setItem('task-mutation-triggering-state-params', JSON.stringify(parameters));
    }

    redirectToStateInSessionStore() {
        const state = JSON.parse(sessionStorage.getItem('task-mutation-triggering-state'));
        const params = JSON.parse(sessionStorage.getItem('task-mutation-triggering-state-params'))
        this.$state.go(state.name, params, { reload: true });
    }

    clearTaskMutationTrackingInSessionStore() {
        sessionStorage.removeItem('task-mutation-triggering-state');
        sessionStorage.removeItem('task-mutation-triggering-state-params');
    }

    displayStatesInConsole(fromState, toState) {
        console.clear();
        console.log('> from state:\n', fromState);
        console.log('> to state:\n', toState);
    }

}


/** WEBPACK FOOTER **
 ** ./src/app/services/taskMutationTrackingService.js
 **/